export default __webpack_public_path__ + "static/localhost-error-noauth-9dd08b69eddd7fa5c504b8a0b5bb7603.png";